<progress class="progress-bar" [value]="value ?? 0" [max]="max" [attr.aria-label]="label">{{ value ?? 0 }}%</progress>
